var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.117 17l-3.28-3.22a7.86 7.86 0 001.82-5.05 7.93 7.93 0 10-7.93 7.93 7.86 7.86 0 005.11-1.88l3.24 3.24a.75.75 0 001.06 0 .75.75 0 00-.02-1.02zM2.337 8.71a6.43 6.43 0 1112.86 0 6.43 6.43 0 01-12.86 0z",
    fill: "#36354C"
  })));
}
export default SvgSearchIcon;